var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('HeaderImage'),_c('Introduction'),_c('Nav'),_c('TopName'),_c('HeaderContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }